import { Grid, SxProps } from '@mui/material';

export const DpSEOSectionDeporteEntrenamiento = ({
	children,
	...props
}: {
	children: React.ReactNode;
	sx?: SxProps;
}) => (
	<Grid item xs={12} {...props}>
		{children}
	</Grid>
);
